export default __webpack_public_path__ + "85d8d8a.png";